import React, { useState } from 'react';
import { useAppContext } from '../../context/AppContext';

export default function ExpenseTable() {
    const { expenses, updateExpense, deleteExpense } = useAppContext();
    const [editingId, setEditingId] = useState(null);
    const [editForm, setEditForm] = useState({
        description: '',
        amount: '',
        type: 'variavel',
        date: ''
    });
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12;

    if (!expenses.length) {
        return (
            <div className="alert alert-light border">
                Nenhuma despesa registrada ainda.
            </div>
        );
    }

    const format = (v) => v.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    const sorted = [...expenses].sort((a, b) => (a.date < b.date ? 1 : -1));

    // Paginação
    const totalPages = Math.ceil(sorted.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentExpenses = sorted.slice(startIndex, endIndex);

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleEdit = (expense) => {
        setEditingId(expense.id);
        setEditForm({
            description: expense.description,
            amount: expense.amount,
            type: expense.type,
            date: expense.date
        });
    };

    const handleCancelEdit = () => {
        setEditingId(null);
        setEditForm({ description: '', amount: '', type: 'variavel', date: '' });
    };

    const handleSaveEdit = async (id) => {
        try {
            await updateExpense(id, {
                description: editForm.description,
                amount: Number(editForm.amount),
                type: editForm.type,
                date: editForm.date
            });
            setEditingId(null);
            setEditForm({ description: '', amount: '', type: 'variavel', date: '' });
        } catch (err) {
            alert('Erro ao atualizar despesa');
        }
    };

    const handleDelete = async (id, description) => {
        if (window.confirm(`Excluir despesa "${description}"?`)) {
            try {
                await deleteExpense(id);
            } catch (err) {
                alert('Erro ao excluir despesa');
            }
        }
    };

    return (
        <div className="card shadow-sm">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h2 className="h5 mb-0">📊 Histórico de despesas</h2>
                    <span className="badge bg-secondary">
                        {sorted.length} {sorted.length === 1 ? 'despesa' : 'despesas'}
                    </span>
                </div>
                <div className="row g-3">
                    {currentExpenses.map((e) => (
                        <div key={e.id} className="col-12 col-md-6 col-lg-4">
                            <div className="card h-100 border shadow-sm">
                                <div className="card-body p-3">
                                    {editingId === e.id ? (
                                        // Formulário de edição
                                        <div>
                                            <div className="mb-2">
                                                <label className="form-label small fw-semibold">Descrição</label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={editForm.description}
                                                    onChange={(ev) => setEditForm({ ...editForm, description: ev.target.value })}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label className="form-label small fw-semibold">Valor</label>
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">R$</span>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        className="form-control"
                                                        value={editForm.amount}
                                                        onChange={(ev) => setEditForm({ ...editForm, amount: ev.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="mb-2">
                                                <label className="form-label small fw-semibold">Tipo</label>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={editForm.type}
                                                    onChange={(ev) => setEditForm({ ...editForm, type: ev.target.value })}
                                                >
                                                    <option value="fixa">Fixa</option>
                                                    <option value="variavel">Variável</option>
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label small fw-semibold">Data</label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    value={editForm.date}
                                                    onChange={(ev) => setEditForm({ ...editForm, date: ev.target.value })}
                                                />
                                            </div>
                                            <div className="d-flex gap-2">
                                                <button
                                                    className="btn btn-sm btn-success flex-fill"
                                                    onClick={() => handleSaveEdit(e.id)}
                                                >
                                                    <i className="bi bi-check-lg me-1"></i>Salvar
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-secondary flex-fill"
                                                    onClick={handleCancelEdit}
                                                >
                                                    <i className="bi bi-x-lg me-1"></i>Cancelar
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        // Visualização normal
                                        <>
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <div className="flex-grow-1">
                                                    <div className="fw-semibold text-truncate" title={e.description}>
                                                        {e.description}
                                                    </div>
                                                    <div className="small text-muted mt-1">
                                                        <i className="bi bi-calendar3 me-1"></i>
                                                        {new Date(e.date).toLocaleDateString('pt-BR')}
                                                    </div>
                                                </div>
                                                <span className={`badge ${e.type === 'fixa' ? 'bg-primary' : 'bg-secondary'}`}>
                                                    {e.type === 'fixa' ? 'Fixa' : 'Variável'}
                                                </span>
                                            </div>
                                            <div className="mt-2 pt-2 border-top">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <span className="text-muted small">Valor:</span>
                                                    <span className="fw-bold text-danger fs-6">
                                                        R$ {format(e.amount)}
                                                    </span>
                                                </div>
                                                <div className="d-flex gap-2">
                                                    <button
                                                        className="btn btn-sm btn-outline-primary flex-fill"
                                                        onClick={() => handleEdit(e)}
                                                        title="Editar"
                                                    >
                                                        <i className="bi bi-pencil-fill"></i>
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-outline-danger flex-fill"
                                                        onClick={() => handleDelete(e.id, e.description)}
                                                        title="Excluir"
                                                    >
                                                        <i className="bi bi-trash-fill"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Paginação */}
                {totalPages > 1 && (
                    <div className="mt-4 d-flex justify-content-center align-items-center">
                        <nav>
                            <ul className="pagination pagination-sm mb-0">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={() => goToPage(currentPage - 1)}>
                                        <i className="bi bi-chevron-left"></i>
                                    </button>
                                </li>

                                {[...Array(totalPages)].map((_, index) => {
                                    const page = index + 1;
                                    // Mostrar apenas algumas páginas ao redor da atual
                                    if (
                                        page === 1 ||
                                        page === totalPages ||
                                        (page >= currentPage - 1 && page <= currentPage + 1)
                                    ) {
                                        return (
                                            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                                <button className="page-link" onClick={() => goToPage(page)}>
                                                    {page}
                                                </button>
                                            </li>
                                        );
                                    } else if (page === currentPage - 2 || page === currentPage + 2) {
                                        return (
                                            <li key={page} className="page-item disabled">
                                                <span className="page-link">...</span>
                                            </li>
                                        );
                                    }
                                    return null;
                                })}

                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={() => goToPage(currentPage + 1)}>
                                        <i className="bi bi-chevron-right"></i>
                                    </button>
                                </li>
                            </ul>
                        </nav>
                        <div className="ms-3 text-muted small">
                            Página {currentPage} de {totalPages}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
